import api from '@/utils/api';

/**
 * Get all categories
 * @returns {Promise}
 */
const getCategoriesSelectApi = () => {
  const url = 'conf/categories-select';
  return api.get(url);
};

export default getCategoriesSelectApi;
